<div class="container-fluid py-4">
  <!-- Toast -->
  <div
    *ngIf="toastVisible"
    class="custom-toast"
    [ngClass]="{
      success: toastType === 'success',
      error: toastType === 'error',
    }"
  >
    <i
      class="me-2"
      [class.bi-check-circle-fill]="toastType === 'success'"
      [class.bi-exclamation-circle-fill]="toastType === 'error'"
    ></i>
    {{ toastMessage }}
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div
      class="spinner-border text-white"
      role="status"
      style="width: 3rem; height: 3rem"
    >
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-3 text-white-50">Loading employees...</p>
  </div>
  <!-- Header -->
  <div
    class="header-card bg-linear-gradient-purple text-white shadow-sm rounded-3 mb-4 p-3 p-md-4"
  >
    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center"
    >
      <div class="mb-3 mb-md-0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <button class="btn btn-outline-light btn-sm px-3" (click)="goBack()">
            <i class="bi bi-arrow-left me-1"></i>Back
          </button>
          <h4 class="mb-0 fw-semibold">
            <i class="bi bi-people-fill me-2"></i>Manage Employees
          </h4>
        </div>
        <p class="mb-0 opacity-75 small">
          <i class="bi bi-shop me-1"></i>{{ orgName }}
        </p>
      </div>

      <button
        class="btn btn-light btn-sm px-3 py-2 mt-2 mt-md-0 shadow-sm"
        data-bs-toggle="modal"
        data-bs-target="#addEmployeeModal"
      >
        <i class="bi bi-plus-circle me-2"></i>Add Employee
      </button>
    </div>

    <div *ngIf="canRunCashierBackfill" class="mt-3 d-flex justify-content-end">
      <button
        class="btn btn-warning btn-sm"
        type="button"
        (click)="runCashierBackfill()"
        [disabled]="backfillingCashier"
      >
        <i class="bi bi-database-gear me-2"></i>
        {{ backfillingCashier ? "Updating..." : "Update Database (Cashier)" }}
      </button>
    </div>
  </div>

  <!-- Employees Accordion -->
  <div
    *ngIf="!isLoading && employees.length"
    class="accordion"
    id="employeeAccordion"
  >
    <div
      *ngFor="let emp of employees; let i = index"
      class="accordion-item employee-accordion mb-3 rounded-3 overflow-hidden"
    >
      <h2 class="accordion-header" [id]="'heading' + i">
        <div
          class="d-flex justify-content-between align-items-center w-100 px-3 py-2 gradient-header"
        >
          <button
            class="accordion-button collapsed bg-transparent shadow-none border-0 text-white"
            type="button"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse' + i"
            aria-expanded="false"
            [attr.aria-controls]="'collapse' + i"
          >
            <div class="w-100">
              <!-- Top Row -->
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-2">
                  <span class="fw-bold">{{ emp.Name }}</span>
                  <span
                    class="opacity-75"
                    *ngIf="emp.role !== 'admin' && emp.role !== 'manager'"
                    >(PIN: {{ emp.Pin }})</span
                  >

                  <span class="opacity-75" *ngIf="emp.role !== 'employee'"
                    >({{ emp.role }})</span
                  >
                </div>
              </div>

              <!-- Flags (Inline and subtle) -->
              <div
                *ngIf="
                  (emp.incompleteAvailability ||
                    emp.incompleteFullName ||
                    emp.incompletePassword) &&
                  emp.role !== 'admin' &&
                  emp.role !== 'manager'
                "
                class="mt-1 ps-2 d-flex flex-wrap align-items-center gap-2 small text-white-50"
              >
                <span>Flags:</span>
                <span
                  *ngIf="emp.incompleteAvailability"
                  class="badge bg-danger text-white fw-normal"
                >
                  <i class="bi bi-exclamation-triangle me-1"></i>Incomplete
                  Availability
                </span>
                <span
                  *ngIf="emp.incompleteFullName"
                  class="badge bg-warning text-dark fw-normal"
                >
                  <i class="bi bi-person-x me-1"></i>Missing Full Name
                </span>
                <span
                  *ngIf="emp.incompletePassword"
                  class="badge bg-info text-dark fw-normal"
                >
                  <i class="bi bi-lock-fill me-1"></i>Missing Password
                </span>
              </div>
            </div>
          </button>

          <!-- Edit Button -->
          <button
            class="btn btn-sm btn-outline-light ms-2"
            type="button"
            (click)="openEditOffcanvas(emp)"
            title="Edit Employee"
          >
            <i class="bi bi-pencil-square"></i>
          </button>
        </div>
      </h2>

      <div
        [id]="'collapse' + i"
        class="accordion-collapse collapse"
        [attr.aria-labelledby]="'heading' + i"
        data-bs-parent="#employeeAccordion"
      >
        <div class="accordion-body bg-white text-dark rounded-bottom">
          <div class="row gy-3">
            <!-- Employee Details -->
            <div class="col-12 col-md-6">
              <h6 class="fw-bold text-gradient mb-2">
                <i class="bi bi-person-badge me-2"></i>Employee Details
              </h6>
              <div class="small">
                <p class="mb-1">
                  <i class="bi bi-key me-2 text-gradient"></i>
                  <strong>Key Holder:</strong>
                  <span
                    [ngClass]="emp.keyHolder ? 'text-success' : 'text-muted'"
                  >
                    {{ emp.keyHolder ? "Yes" : "No" }}
                  </span>
                </p>
                <p class="mb-1">
                  <i class="bi bi-clock me-2 text-gradient"></i>
                  <strong>Full Time:</strong>
                  <span
                    [ngClass]="emp.fullTime ? 'text-success' : 'text-muted'"
                  >
                    {{ emp.fullTime ? "Yes" : "No" }}
                  </span>
                </p>
                <p class="mb-1">
                  <i class="bi bi-receipt me-2 text-gradient"></i>
                  <strong>Cashier:</strong>
                  <span
                    [ngClass]="
                      (emp.cashier ?? false) ? 'text-success' : 'text-muted'
                    "
                  >
                    {{ (emp.cashier ?? false) ? "Yes" : "No" }}
                  </span>
                </p>
                <p *ngIf="emp.email" class="mb-1">
                  <i class="bi bi-envelope-check-fill me-2 text-gradient"></i>
                  <strong>Email:</strong> {{ emp.email }}
                </p>
                <p *ngIf="emp.firstName && emp.lastName" class="mb-1">
                  <i class="bi bi-person me-2 text-gradient"></i>
                  <strong>Full Name:</strong>
                  {{ emp.firstName }} {{ emp.lastName }}
                </p>
                <p *ngIf="emp.notes" class="mb-0 mt-2">
                  <i class="bi bi-sticky me-2 text-gradient"></i>
                  <strong>Notes:</strong>
                  <span class="text-muted">{{ emp.notes }}</span>
                </p>
              </div>
            </div>

            <!-- Availability -->
            <div class="col-12 col-md-6">
              <h6 class="fw-bold text-gradient mb-2">
                <i class="bi bi-calendar-week me-2"></i>Weekly Availability
              </h6>
              <ul class="list-unstyled small mb-0">
                <li *ngFor="let day of dayKeys" class="mb-1">
                  <span class="fw-semibold">{{ day }}:</span>
                  <span
                    class="ms-1"
                    [ngClass]="{
                      'text-success fw-semibold':
                        emp.availability &&
                        emp.availability[day] &&
                        emp.availability[day] !== 'off',
                      'text-muted':
                        !emp.availability ||
                        !emp.availability[day] ||
                        emp.availability[day] === 'off',
                    }"
                  >
                    {{ (emp.availability && emp.availability[day]) || "off" }}
                  </span>
                </li>
              </ul>
            </div>

            <!-- Requested Off -->
            <div class="col-12">
              <hr class="my-2" />
              <h6 class="fw-bold text-gradient mb-2">
                <i class="bi bi-calendar-x me-2"></i>Requested Time Off
              </h6>
              <div *ngIf="emp.requestedOff?.length; else noRequests">
                <ul class="list-unstyled small mb-0">
                  <li *ngFor="let req of emp.requestedOff" class="mb-1">
                    <i
                      class="bi bi-circle-fill me-2"
                      style="font-size: 0.5rem"
                    ></i>
                    <span class="fw-semibold">{{ req.date }}</span>
                    <span
                      class="badge ms-2"
                      [ngClass]="{
                        'bg-success': req.status === 'approved',
                        'bg-warning text-dark': req.status === 'pending',
                        'bg-danger': req.status === 'declined',
                      }"
                    >
                      {{ req.status | titlecase }}
                    </span>
                    <small *ngIf="req.approvedBy" class="text-muted ms-1">
                      (by {{ req.approvedBy }})
                    </small>
                  </li>
                </ul>
              </div>
              <ng-template #noRequests>
                <p class="text-muted small mb-0">
                  <i class="bi bi-info-circle me-1"></i>No time-off requests
                </p>
              </ng-template>

              <div class="text-end mt-3">
                <button
                  class="btn btn-outline-danger btn-sm"
                  type="button"
                  (click)="deleteEmployee(emp)"
                  title="Delete Employee"
                >
                  <i class="bi bi-trash me-1"></i>Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- No Employees -->
  <div
    *ngIf="!isLoading && !employees.length"
    class="text-center py-5 empty-state"
  >
    <i class="bi bi-people display-1 text-white-50 opacity-25"></i>
    <h4 class="mt-3 text-white">No Employees Found</h4>
    <p class="text-white-50">Add your first employee to get started</p>
    <button
      class="btn btn-gradient mt-3"
      data-bs-toggle="modal"
      data-bs-target="#addEmployeeModal"
    >
      <i class="bi bi-plus-circle me-2"></i>Add Employee
    </button>
  </div>
</div>

<!-- Add Employee Modal -->
<div
  class="modal fade"
  id="addEmployeeModal"
  tabindex="-1"
  aria-labelledby="addEmployeeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content custom-modal">
      <div class="modal-header bg-linear-gradient-purple text-white border-0">
        <h5 class="modal-title" id="addEmployeeModalLabel">
          <i class="bi bi-person-plus me-2"></i>Add New Employee
        </h5>
        <button
          type="button"
          class="btn-close btn-close-white"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <form [formGroup]="addEmployeeForm" (ngSubmit)="onAddEmployeeSubmit()">
        <div class="modal-body">
          <div class="mb-3">
            <label for="empName" class="form-label fw-bold">
              <i class="bi bi-person me-2"></i>Employee Name
            </label>
            <input
              type="text"
              class="form-control custom-input"
              id="empName"
              formControlName="Name"
              placeholder="Enter full name"
            />
          </div>

          <div class="mb-3">
            <label for="empPin" class="form-label fw-bold">
              <i class="bi bi-shield-lock me-2"></i>4-Digit PIN
            </label>
            <input
              type="text"
              inputmode="numeric"
              maxlength="4"
              class="form-control custom-input"
              id="empPin"
              formControlName="Pin"
              placeholder="Enter 4-digit PIN"
            />
            <small class="text-muted">Used for employee login</small>
          </div>

          <div class="form-check custom-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              id="empKeyHolder"
              formControlName="keyHolder"
            />
            <label class="form-check-label" for="empKeyHolder">
              <i class="bi bi-key me-2"></i>Key Holder
            </label>
          </div>

          <div class="form-check custom-check">
            <input
              class="form-check-input"
              type="checkbox"
              id="empFullTime"
              formControlName="fullTime"
            />
            <label class="form-check-label" for="empFullTime">
              <i class="bi bi-clock me-2"></i>Full Time Employee
            </label>
          </div>

          <div class="form-check custom-check mt-2">
            <input
              class="form-check-input"
              type="checkbox"
              id="empCashier"
              formControlName="cashier"
            />
            <label class="form-check-label" for="empCashier">
              <i class="bi bi-receipt me-2"></i>Cashier
            </label>
          </div>
        </div>
        <div class="modal-footer border-0">
          <button
            type="button"
            class="btn btn-outline-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-gradient"
            [disabled]="addEmployeeForm.invalid || isSubmitting"
          >
            <span *ngIf="!isSubmitting">
              <i class="bi bi-check-circle me-2"></i>Add Employee
            </span>
            <span *ngIf="isSubmitting">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Adding...
            </span>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Edit Employee Offcanvas -->
<div
  class="offcanvas offcanvas-end custom-offcanvas"
  tabindex="-1"
  id="editEmployeeOffcanvas"
  aria-labelledby="editEmployeeOffcanvasLabel"
>
  <div class="offcanvas-header bg-linear-gradient-purple text-white">
    <h5 class="offcanvas-title" id="editEmployeeOffcanvasLabel">
      <i class="bi bi-pencil-square me-2"></i>Edit Employee
    </h5>
    <button
      type="button"
      class="btn-close btn-close-white"
      data-bs-dismiss="offcanvas"
      aria-label="Close"
    ></button>
  </div>
  <div class="offcanvas-body">
    <form [formGroup]="editEmployeeForm" (ngSubmit)="onEditEmployeeSubmit()">
      <div class="mb-3">
        <label for="editName" class="form-label fw-bold">
          <i class="bi bi-person me-2"></i>Name
        </label>
        <input
          type="text"
          class="form-control custom-input"
          id="editName"
          formControlName="Name"
        />
      </div>

      <div class="mb-3">
        <label for="editPin" class="form-label fw-bold">
          <i class="bi bi-shield-lock me-2"></i>PIN
        </label>
        <input
          type="text"
          inputmode="numeric"
          maxlength="4"
          class="form-control custom-input"
          id="editPin"
          formControlName="Pin"
        />
      </div>

      <div class="form-check custom-check mb-2">
        <input
          class="form-check-input"
          type="checkbox"
          id="editKeyHolder"
          formControlName="keyHolder"
        />
        <label class="form-check-label" for="editKeyHolder">
          <i class="bi bi-key me-2"></i>Key Holder
        </label>
      </div>

      <div class="form-check custom-check mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          id="editFullTime"
          formControlName="fullTime"
        />
        <label class="form-check-label" for="editFullTime">
          <i class="bi bi-clock me-2"></i>Full Time
        </label>
      </div>

      <div class="form-check custom-check mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          id="editCashier"
          formControlName="cashier"
        />
        <label class="form-check-label" for="editCashier">
          <i class="bi bi-receipt me-2"></i>Cashier
        </label>
      </div>

      <div class="mb-3">
        <label for="editNotes" class="form-label fw-bold">
          <i class="bi bi-sticky me-2"></i>Notes
        </label>
        <textarea
          class="form-control custom-input"
          id="editNotes"
          rows="3"
          formControlName="notes"
          placeholder="Add any notes about this employee..."
        ></textarea>
      </div>

      <hr class="my-4" />

      <h6 class="mb-3 fw-bold text-gradient">
        <i class="bi bi-calendar-week me-2"></i>Weekly Availability
      </h6>

      <div class="alert alert-info mb-3 small">
        <i class="bi bi-info-circle me-2"></i>
        <strong>Format:</strong> Use "off" or "9:00 AM - 5:00 PM" (any minutes
        00-59 accepted)
      </div>

      <div *ngFor="let day of dayKeys" class="mb-3">
        <label [for]="'edit' + day" class="form-label fw-semibold">
          {{ day }}
        </label>

        <div class="input-group">
          <input
            type="text"
            class="form-control custom-input"
            [id]="'edit' + day"
            [formControlName]="day"
            [class.is-invalid]="hasTimeError(day)"
            (blur)="formatTimeInput(day)"
            placeholder="e.g., 9:30 AM - 6:00 PM or off"
            autocomplete="off"
          />

          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="setDayOff(day)"
            title="Set to off"
          >
            <i class="bi bi-x-circle"></i>
          </button>
        </div>

        <!-- Error message -->
        <div *ngIf="hasTimeError(day)" class="text-danger small mt-1">
          <i class="bi bi-exclamation-triangle me-1"></i>
          Must be "off" or format like "9:30 AM - 6:00 PM"
        </div>
      </div>

      <button
        type="submit"
        class="btn btn-gradient w-100 mt-4"
        [disabled]="editEmployeeForm.invalid"
      >
        <i class="bi bi-save me-2"></i>Save Changes
      </button>
    </form>
  </div>
</div>
